import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHeader } from "@/components/site/PageHeader";
import { Reveal } from "@/components/site/Reveal";
import { BLOG_POSTS } from "@/blogData";

export default function BlogPage() {
  return (
    <>
      <PageHeader
        overline="Family Protection Insights"
        title="The Heritage"
        accent="journal."
        subtitle="Plain-English guides on life insurance, healthcare, legal protection, and building a legacy that lasts."
      />

      <section className="relative pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.06}>
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0a192f] hover:border-[#bf953f]/45 transition-colors duration-500"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="h-52 w-full object-cover transition-transform duration-700 group-hover:scale-[1.05]"
                    loading="lazy"
                  />
                  <span className="absolute top-4 left-4 rounded-full bg-black/70 backdrop-blur px-3.5 py-1.5 font-body text-[11px] tracking-widest uppercase text-[#d4af37]">
                    {p.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <p className="font-body text-xs text-white/40">{p.date} · {p.readTime}</p>
                  <h2 className="mt-3 font-serif-display text-2xl leading-snug text-white group-hover:text-[#fcf6ba] transition-colors duration-300">
                    {p.title}
                  </h2>
                  <p className="mt-3 flex-1 font-body font-light text-sm leading-relaxed text-white/55">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 font-body text-xs tracking-widest uppercase text-[#d4af37]">
                    Read Article <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
